import {
  defineElement,
  ElementDefinition,
} from '@amzn/exs-elements/web-component';
import serverDefinition from './definition';
import { getWebVitalsPlugin } from '../../common/webvitals-plugin';
import { getLumberjackPlugin } from '../../common/lumberjack-plugin';
import { ExsElementsHydrationPlugin } from '@amzn/exs-gem-react/plugins';
import { ClickstreamPlugin, FontEmbedPlugin } from '@amzn/exs-elements/plugins';
import { sharedClickstreamDimensions } from '../../common/settings';

export const amazonCartDefinition: ElementDefinition = {
  ...serverDefinition,
  plugins: [
    getWebVitalsPlugin(serverDefinition.tagName),
    getLumberjackPlugin(serverDefinition.tagName),
    ClickstreamPlugin({
      elementTagName: serverDefinition.tagName,
      ...sharedClickstreamDimensions,
    }),
    ExsElementsHydrationPlugin({
      /**
       * the path is pointing to the compiled version of
       * src/elements/amazon-cart/v1.0/entry-client.ts
       *
       * you can find it under
       * dist/assets/elements/amazon-cart/v1.0/entry-client.js
       */
      clientEntryPath: '/elements/amazon-cart/v1.0/entry-client.js',
    }),
    FontEmbedPlugin({
      fonts: [
        {
          vendor: 'Amazon',
          family: 'Amazon Ember',
        },
      ],
    }),
  ],
};

defineElement(amazonCartDefinition);
